import { useState } from "react";
import assetPath from "../../utils/assetPath";
import { useTiersSummary } from "../../services/loyalty";

const imgInsightIcon = assetPath("/icons/insights-icon.png");

const TierDistributionChart = () => {
  const { data, isLoading } = useTiersSummary();
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const segments = data?.tiers.filter((t) => t.percentage > 0) ?? [];

  return (
    <div
      className="rounded-[8px] px-8 py-8 flex flex-col gap-6"
      style={{ background: "linear-gradient(171deg, #eeeee5 0%, #e9e9df 100%)" }}
    >
      {/* Header */}
      <div className="flex items-center gap-4">
        <img src={imgInsightIcon} alt="" className="w-[40px] h-[35px] shrink-0" />
        <div className="flex flex-col gap-1">
          <p className="text-[14px] font-semibold leading-none text-content-heading">
            Distribution Insight
          </p>
          <p className="text-[14px] font-normal leading-none text-content-label">
            User base spread across loyalty levels
          </p>
        </div>
      </div>

      {/* Stacked bar */}
      {isLoading ? (
        <div className="h-4 rounded-xl bg-border-subtle animate-pulse" />
      ) : (
        <div className="flex flex-col gap-2">
          <div className="flex h-4 rounded-xl overflow-visible">
            {segments.map((seg) => (
              <div
                key={seg.tier_id}
                className="relative"
                style={{ width: `${seg.percentage}%`, backgroundColor: seg.color, height: "16px" }}
                onMouseEnter={() => setHoveredId(seg.tier_id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {hoveredId === seg.tier_id && (
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-10 whitespace-nowrap rounded-[6px] px-3 py-1.5 text-[12px] font-medium text-white bg-gray-800 pointer-events-none">
                    {seg.customer_count.toLocaleString()} {seg.customer_count === 1 ? "customer" : "customers"}
                    <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-r-[5px] border-t-[5px] border-l-transparent border-r-transparent border-t-gray-800" />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Labels */}
          <div className="flex flex-wrap gap-y-1">
            {segments.map((seg) => (
              <div key={seg.tier_id} style={{ width: `${seg.percentage}%` }}>
                <span className="text-[12px] font-medium uppercase whitespace-nowrap text-content-label">
                  {seg.tier_name} ({seg.percentage}%)
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TierDistributionChart;
